import AttendeeAutocomplete from "components/AgencySelect/AttendeeAutocomplete"

type Props = {
  attendees: Attendee[]
  onChange: (attendees: Attendee[]) => void
}

const AttendanceFilter = ({ attendees, onChange }: Props) => {
  return (
    <AttendeeAutocomplete
      className="min-w-[280px] flex-1"
      label="Chọn nhân viên"
      multiple
      onChange={onChange}
      size="small"
      value={attendees}
    />
  )
}

export default AttendanceFilter
